import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CloseableSnackbarComponent } from '../../shared/components/closeable-snackbar/closeable-snackbar.component';
@Injectable({
  providedIn: 'root'
})
export class SnackBarAlertsService {
  private snackBarDuration = 3000;

  constructor(private snackBar: MatSnackBar) {}

  /**
   * Show a SnackBar, a brief message about app processes at the bottom of the screen.
   * @param message - the message to display
   * @param duration - the amount of time to display the message in milliseconds (default: 3 seconds)
   */
  show(message: string, duration?: number) {
    this.snackBar.openFromComponent(CloseableSnackbarComponent, {
      duration: duration || this.snackBarDuration,
      data: {
        message
      }
    });
  }
}
